module.exports = __webpack_public_path__ + "img/ps.6c9ce492.png";